import React, { Component } from 'react';
import _ from 'lodash';
import {
  Accordion,
  Checkbox,
  Dropdown,
  Divider,
  Grid,
  Container,
  Loader,
  Segment
} from 'semantic-ui-react';
import qs from 'qs';

import { getAccounts } from '../../services/AccountService';
import { updateUrl } from '../../utils/urls';
import { getErrorReports } from '../../services/AdErrorReportService';
import ErrorReportDetail from './ErrorReportDetail';

class AdErrorReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      token: props.getFbToken(),
      adAccountId: '-1',
      adAccountName: 'All',
      selectedYear: '',
      selectedMonth: '',
      accounts: [],
      accountOptions: [],
      reports: null,
      expandAll: false,
      campaigns: []
    };
  }
  componentDidMount() {
    this.props.setSectionTitle('Ad Error Report');
    this.props.saveGTMEvent('Ad Error Report', 'Ad Error Report');
    this.getAdAccounts().then(() => {
      getErrorReports().then((result) => {
        const allAccountsOption = {
          key: '-1',
          value: '-1',
          text: 'All Accounts'
        };
        const campaignsWithQC = [
          ...new Set(result.reports.map((r) => r.month))
        ];
        const yearsWithQC = [...new Set(result.reports.map((r) => r.year))];
        const accountIds = [
          ...new Set(result.reports.map((r) => r.account_id))
        ];
        const accountsWithQCs = _.sortBy(
          this.state.accounts
            .filter((account) =>
              accountIds.find((id) => id === account.account_id)
            )
            .map((acc, index) => ({
              key: index,
              value: acc.account_id,
              text: acc.name
            })),
          'text'
        );
        accountsWithQCs.unshift(allAccountsOption);
        this.setState({
          campaigns: campaignsWithQC.map((c) => ({
            key: c,
            value: c,
            text: c
          })),
          years: yearsWithQC.map((c) => ({ key: c, value: c, text: c })),
          accountOptions: accountsWithQCs
        });
        this.preSelectFields();
      });
    });
  }

  onAccountSelect = (event, data) => {
    // get Campaigns, then get ads
    const n = _.find(data.options, (o) => o.value === data.value);
    const accountId = n.value;
    const accountName = n.text;
    updateUrl(accountName, '', '');
    this.selectAccount(accountId, accountName);
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    updateUrl(this.state.adAccountName, value, '');
    this.selectYear(value);
  };

  onMonthSelect = (event, data) => {
    const n = _.find(data.options, (o) => o.value === data.value);
    const monthYear = n.text;
    updateUrl(this.state.adAccountName, this.state.selectedYear, monthYear);
    this.selectMonth(monthYear);
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );
      this.setState({
        accounts: _.sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  getReports = async (monthYear) => {
    const params = {
      year: this.state.selectedYear,
      month: monthYear
    };
    if (this.state.adAccountId !== '-1') {
      params.account_id = this.state.adAccountId;
    }
    const result = await getErrorReports(params);
    return result;
  };

  preSelectFields = () => {
    if (window.location.hash !== '') {
      const url = window.location.hash.replace('#', '');
      const urlParams = qs.parse(url);
      const account = _.find(
        this.state.accountOptions,
        (a) => a.text && a.text.indexOf(urlParams.account) !== -1
      );
      if (account) {
        this.selectAccount(account.value, account.text);
        const selectedYear = urlParams.year;
        if (selectedYear) {
          this.selectYear(selectedYear);
          const selectedMonth = urlParams.month;
          if (selectedMonth) {
            this.selectMonth(selectedMonth);
          }
        }
      }
    }
    this.setState({ processing: false });
  };

  selectAccount = (accountId, accountName) => {
    this.setState({
      adAccountId: accountId,
      adAccountName: accountName,
      selectedYear: '',
      selectedMonth: '',
      showYearMonthSelector: true,
      reports: []
    });
  };

  selectYear = (value) => {
    this.setState({
      selectedYear: value,
      selectedMonth: '',
      reports: []
    });
  };

  selectMonth = (monthYear) => {
    this.setState({
      processing: true,
      selectedMonth: monthYear
    });
    // move this inside a promise in get ads
    this.getReports(monthYear).then((result) => {
      const reports = result.reports;
      this.setState({
        processing: false,
        reports
      });
    });
  };
  handleExpandAll = () => {
    this.setState({
      expandAll: !this.state.expandAll
    });
  };
  renderYearDropdown = () => (
    <Dropdown
      disabled={this.state.processing}
      placeholder="Year"
      search
      selection
      value={this.state.selectedYear}
      options={this.state.years}
      onChange={this.onYearSelect}
    />
  );

  renderMonthDropdown = () => (
    <Dropdown
      placeholder="Month"
      search
      selection
      disabled={this.state.processing}
      value={this.state.selectedMonth}
      options={this.state.campaigns}
      onChange={this.onMonthSelect}
    />
  );

  renderReports = () => {
    const { processing, reports } = this.state;
    if (processing) {
      return <Loader />;
    } else if (reports && reports !== null && reports.length > 0) {
      return (
        <Segment>
          <Accordion fluid styled>
            {_.map(reports, (r) => (
              <ErrorReportDetail
                expandAll={this.state.expandAll}
                accounts={this.state.accountOptions}
                getFbToken={this.props.getFbToken}
                errorReport={r}
              />
            ))}
          </Accordion>
        </Segment>
      );
    }
    return null;
  };
  render() {
    return (
      <Container>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Dropdown
                placeholder="Ad Accounts"
                search
                selection
                disabled={this.state.processing}
                value={this.state.adAccountId}
                options={this.state.accountOptions}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              {this.renderYearDropdown()}
              <Divider hidden />
              {this.renderMonthDropdown()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <strong>Expand all</strong>{' '}
        <Checkbox
          toggle
          onChange={this.handleExpandAll}
          checked={this.state.expandAll}
        />
        {this.renderReports()}
      </Container>
    );
  }
}

export default AdErrorReport;



// WEBPACK FOOTER //
// ./src/screens/AdErrorReport/AdErrorReport.js